import { Node_Type } from './../../ricos-schema/next-schema';

const listSymbolMap: { [key in Node_Type]?: string[] } = {
  [Node_Type.BULLETED_LIST]: ['disc', 'circle', 'square'],
  [Node_Type.ORDERED_LIST]: ['decimal', 'lower-latin', 'lower-roman'],
};

export function getListSymbol(indentation: number, nodeTypeName: Node_Type): string {
  const listSymbolList = listSymbolMap[nodeTypeName];
  return listSymbolList ? listSymbolList[indentation % listSymbolList.length] : '';
}
